/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import utils from 'util/utils';
import PropTypes from 'prop-types';
import VideoMuteButton from './VideoMuteButton';
import AudioSettingsButton from './AudioSettingsButton';
import JoinAudioButton from './JoinAudioButton';
import SpeakerButton from './SpeakerButton';
import MicrophoneButton from './MicrophoneButton';
import HangupButton from './HangupButton';
import Thumbnail from '../Thumbnail/Thumbnail';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { translate } from 'store/modules/base/i18n/functions';
import { connect } from 'store/modules/base/redux/functions';
import { isLocalTrackMuted } from 'store/modules/base/tracks/functions';
import { MEDIA_TYPE } from 'store/modules/base/media/constants';
import { FILMSTRIP_TYPE } from 'store/modules/filmstrip/constants';
import { LAYOUTS } from 'store/modules/video-layout/constants';
import { useDispatch } from 'react-redux';
import { playSound } from 'store/modules/base/sounds/actions';
import { LEAVE_AUDIO_SOUND_ID } from 'store/modules/chat/constants';

const JoinAudioVideo = (props) => {
  const {
    _userDevice,
    _isVideoOnly,
    _videoMuted,
    _visibleButtons,
    _hideButtons,
    _hideSelfView
  } = props;
  const dispatch = useDispatch();
  const [isUserIdle, setUserIdle] = useState(false);
  const [idleTime, setIdleTime] = useState(
    parseInt(_userDevice?.options?.timerLimit) * 60
  );
  const intervalRef = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [isActive, setActive] = useState(false);
  const [showCountDownTimer, setShowCountDownTimer] = useState(false);

  useEffect(() => {
    setIdle(_isVideoOnly);
  }, [_isVideoOnly]);

  useEffect(() => {
    if (idleTime !== parseInt(_userDevice?.options?.timerLimit) * 60) {
      setShowCountDownTimer(idleTime < 11);
      if (idleTime < 1) {
        //  handleLeaveAudio();
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = null;
        setUserIdle(false);
        setActive(true);
        setShowCountDownTimer(false);
        leaveAudio();
      }
    }
  }, [idleTime]);
  function startIdleTimer() {
    setUserIdle(true);
    setActive(false);
    setIdleTime(parseInt(_userDevice?.options?.timerLimit ?? 10) * 60);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setIdleTime((prev) => prev - 1);
    }, 1000);
  }

  function leaveAudio() {
    APP.conference.handleJoinLeaveAudio('off');
    dispatch(playSound(LEAVE_AUDIO_SOUND_ID));
    //  props.dispatch(muteLocal(true, MEDIA_TYPE.AUDIO));
    //  props.dispatch(setVideoOnly(true));
    // // @ts-ignore
    //  props._conference.sendCommand('customFakeSpeaker', {
    //     attributes: { xmlns: 'http://jabber.org/protocol/customFakeSpeaker' },
    //     value: 'off'
    // });
    // // @ts-ignore
    //  props._conference.sendCommand('customUserSpeaker', {
    //     attributes: { xmlns: 'http://jabber.org/protocol/customUserSpeaker' },
    //     value: 'off'
    // });
  }
  function setIdle(isActive) {
    if (isActive) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = null;
      setTimeout(() => {
        setUserIdle(false);
        setActive(true);
        setIdleTime(parseInt(_userDevice?.options?.timerLimit) * 60);
        setShowCountDownTimer(false);
      }, 1000);
    } else {
      if (!_isVideoOnly && _userDevice?.options?.showTimer == 1) {
        startIdleTimer();
      }
    }
  }

  return (
    <div className="middle">
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <VideoMuteButton
          visible={!_hideButtons && _userDevice?.type !== 'device'}
        />
        {_userDevice?.options?.showTimer != 0 &&
          !_hideButtons &&
          isUserIdle &&
          !_isVideoOnly && (
            <Box className="audioTimerContainer">
              <Box className="timerText">
                {` ${utils.formatNumbers(
                  utils.getHours(idleTime)
                )}:${utils.formatNumbers(utils.getMinutes(idleTime))}`}
              </Box>
              <Box className="timerLabel"> time remaining</Box>
            </Box>
          )}
        {_visibleButtons && !_hideButtons && (
          <div className="filmstrip__videos" id="buttons-container">
            {!_isVideoOnly &&
            _userDevice?.options?.showMicrophoneButton == 1 ? (
              <AudioSettingsButton isDesktop={true} />
            ) : _userDevice?.options?.showMicrophoneButton == 0 ? (
              <MicrophoneButton isDesktop={true} />
            ) : null}

            {!_videoMuted &&
            _userDevice?.options?.showJoinLeaveAudioButton == 1 ? (
              <JoinAudioButton
                isDesktop={true}
                onPress={(muted) => setIdle(muted)}
              />
            ) : _userDevice?.options?.showJoinLeaveAudioButton == 0 ? (
              <SpeakerButton isDesktop={true} />
            ) : null}
          </div>
        )}
        {_userDevice?.options?.showTimer != 0 &&
          isUserIdle &&
          !_isVideoOnly &&
          showCountDownTimer && (
            <Box
              className="shortTimerContainer"
              onClick={() => {
                if (intervalRef.current) clearInterval(intervalRef.current);
                setUserIdle(false);
                setActive(true);
                setShowCountDownTimer(false);
                startIdleTimer();
              }}>
              <div className="idleTimer">{idleTime}</div>
              <div className="idleText">
                The audio is about to expire. Tap anywhere to keep alive
              </div>
            </Box>
          )}
      </div>
      <div className="filmstrip__videos" id="filmstripLocalVideo">
        {_userDevice?.type !== 'device' && !_hideButtons && (
          <HangupButton
            buttonKey="hangup"
            type="hangup"
            key="hangup-button"
            visible={true}
          />
        )}
        {!_videoMuted && !_hideSelfView && (
          <div
            id="filmstripLocalVideoThumbnail"
            style={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
            <Thumbnail
              filmstripType={FILMSTRIP_TYPE.MAIN}
              _currentLayout={LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW}
              showPopup={false}
              key="local"
            />
          </div>
        )}
      </div>
    </div>
  );
};
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state, ownProps) {
  const { clientWidth, clientHeight } = state['features/base/responsive-ui'];
  const tracks = state['features/base/tracks'];
  const device = state['features/login'].user?.device;
  return {
    _userDevice: device,
    _clientWidth: clientWidth,
    _clientHeight: clientHeight,
    _visibleButtons: clientWidth > 500 && clientHeight > 500,
    _hideButtons: ownProps.idleMode && device?.options?.hideButtons === 1,
    _hideSelfView: ownProps.idleMode && device?.options?.hideSelfView === 1,
    _isVideoOnly: state['features/settings'].videoOnly,
    _videoMuted: isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO)
  };
}

export default React.memo(
  connect(_mapStateToProps)(translate(withBoundary(JoinAudioVideo)))
);
JoinAudioVideo.propTypes = {
  _userDevice: PropTypes.object,
  _clientWidth: PropTypes.number,
  _clientHeight: PropTypes.number,
  _visibleButtons: PropTypes.bool,
  _hideButtons: PropTypes.bool,
  _hideSelfView: PropTypes.bool,
  _isVideoOnly: PropTypes.bool,
  _videoMuted: PropTypes.bool
};
